import { z } from 'zod';

/**
 * Local copy of AnalyticsCore's player envelope schema.
 * Kept here so marketing-demo boot does not statically import `@playcastdotio/AnalyticsCore`
 * (Vite serves that package under a path containing "Analytics", which ad blockers abort).
 */
const playerEnvelopeSchema = z.object({
  name: z.string().min(1).max(100),
  eventId: z.string().regex(/^[a-z][a-z0-9_]*$/).max(40),
  role: z.enum(['player', 'host', 'spectator', 'celebrity', 'system']),
  flow: z.enum(['quickstart', 'prime', 'pavilion', 'beacon']).optional(),
  campaignId: z.string().optional(),
  sessionId: z.string().optional(),
  persistentId: z.string().optional(),
  playerAuthId: z.string().optional(),
});

export const milestonePageLoadedSchema = playerEnvelopeSchema.extend({
  name: z.literal('Milestone Page Loaded'),
  eventId: z.literal('milestone_page_loaded'),
  campaignId: z.string(),
  pageLoadTime: z.number().optional(),
});

export const milestoneStreamRenderedSchema = playerEnvelopeSchema.extend({
  name: z.literal('Milestone Stream Rendered'),
  eventId: z.literal('milestone_stream_rendered'),
  campaignId: z.string(),
  connectionDurationMs: z.number().optional(),
});

export const milestoneFirstInputSchema = playerEnvelopeSchema.extend({
  name: z.literal('Milestone First Input'),
  eventId: z.literal('milestone_first_input'),
  campaignId: z.string(),
});

export type MilestonePageLoaded = z.infer<typeof milestonePageLoadedSchema>;
export type MilestoneStreamRendered = z.infer<typeof milestoneStreamRenderedSchema>;
export type MilestoneFirstInput = z.infer<typeof milestoneFirstInputSchema>;
